import axios from 'axios';

const api = axios.create({
  baseURL: 'https://devgestfete.apbgest.fr/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/authentication/sign-in';
    }
    return Promise.reject(error);
  }
);

export default api;
